import { Switch as FSwitch } from '@forest/forms';
import { connect, mapProps } from '@formily/react';
export const Switch = connect(FSwitch, mapProps({
    value: 'isChecked',
}));
export default Switch;
